import React from "react";
import styled from "styled-components";

import { ReactComponent as CancelledIcon } from "../../../../assets/icons/RedCancelButton.svg";
import { ReactComponent as DoneIcon } from "../../../../assets/icons/GreenDoneButton.svg";
import { Alert } from "../../../../components/Icons";

const Pill = styled.div.attrs((props: { color: string; size: string }) => ({
    color: props.color,
    size: props.size,
}))`
    background-color: ${(props) => props.color};
    color: #1e1e1e;
    padding: 16px 20px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    min-width: ${(props) => props.size};

    svg {
        margin-right: 16px;
    }
`;

interface IStatusPillProps {
    status?: string;
    checkinPending?: boolean;
}

enum Status {
    APROVADO = "APROVADO",
    CANCELADO = "CANCELADO",
    DEFERIDO = "DEFERIDO",
    INDEFERIDO = "INDEFERIDO",
    CONCLUIDO = "CONCLUIDO",
    DONE = "DONE",
    CANCELED = "CANCELED",
}

const StatusPill: React.FC<IStatusPillProps> = ({
    status = "",
    checkinPending = false,
}) => {
    const hasConcludedStatus = [Status.CONCLUIDO].includes(
        status.toUpperCase() as Status
    );

    const approvedStatus = [
        Status.DONE,
        Status.APROVADO,
        Status.CONCLUIDO,
        Status.DEFERIDO,
    ].includes(status.toUpperCase() as Status);

    const approvedStatusText = () => {
        if (status === Status.DONE) {
            return "Aprovado";
        }
        if (status === Status.CANCELED) {
            return "Cancelado";
        }
        return (
            status.slice(0, 1).toUpperCase() +
            status.slice(1).toLocaleLowerCase()
        );
    };

    const pillText = hasConcludedStatus ? "Concluído" : approvedStatusText();

    const checkinPendingComponent = checkinPending && (
        <Pill color="#FFFDD9" size="246px">
            <Alert style={{ fill: "#E1E1E1" }} />
            <span>Pendências de check-ins</span>
        </Pill>
    );

    const PillComponent = !checkinPending && status.length && (
        <Pill color={approvedStatus ? "#EAFFD9" : "#FFE0E0"} size="146px">
            {approvedStatus ? <DoneIcon /> : <CancelledIcon />}
            {pillText}
        </Pill>
    );

    return (
        <>
            {checkinPendingComponent}
            {PillComponent}
        </>
    );
};

export default StatusPill;
